<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="ElderlyCheckinAssess">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            评估列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row style="float: left;">
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" default-expand-all>

                        <el-table-column type="expand" v-if="tableData.length">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item :label="value.name+':'" v-for="(value,i) in props.row.checkinAssessClassDTO1List" :key="i" >
                                        <span>（总得分{{value.sumScore}}）</span> 
                                        <el-button type="text" @click="handleInfo(value.elderlyCheckinAssessItemList)">查看详情</el-button>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>

                        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
                        <el-table-column prop="fraction" label="总分"></el-table-column>
                        <el-table-column prop="checkinAssessLevel" label="护理级别">
                            <template slot-scope="scope">
                                <span v-if="scope.row.checkinAssessLevel==0 ||scope.row.checkinAssessLevel==null">默认级别</span>
                                <span v-if="scope.row.checkinAssessLevel==1">0级（能力完好）</span>
                                <span v-if="scope.row.checkinAssessLevel==2">1级（轻度失能）</span>
                                <span v-if="scope.row.checkinAssessLevel==3">2级（中度失能）</span>
                                <span v-if="scope.row.checkinAssessLevel==4">3级（重度失能）</span>
                                <span v-if="scope.row.checkinAssessLevel==5">4级（极重度失能）</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" label="创建时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="closeGetElderly"  v-bind:CheckinAssessGroup="CheckinAssessGroup" v-bind:checkinAssessItemCode="checkinAssessItemCode" v-on:getList="getList"></GetElderly>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:CheckinAssessGroup="CheckinAssessGroup" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import GetElderly from "./GetElderly";
    import Edit from "./Edit";
    import {getStaffCode,getMenuButton} from "@/utils/auth";
    import Info from "./Info";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalInfo:false,
                showModalGetElderly:false,
                showModalEdit:false,
                dialogVisible:false,
                disabledAdd:true,
                menuButtonList:null,
                tableData:[],
                CheckinAssessGroup:[],
                checkinAssessItemCode:[],
                totalItems: 0,
                elderlyName:"",
                pageSize:20,
                currentPage:1,
                th:0,
            }
        },
        components:{
            GetElderly,Edit,Info
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            closeGetElderly: function () {
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            handleInfo(value) {
                this.$refs.myInfo.init(value);
                this.showModalInfo = !this.showModalInfo;
            },
            closeInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },
            
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ElderlyCheckinAssess/GetPage",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            roomTypeTitle(row){
                if(row.roomType == 0){
                    return "单人间";
                }
                if(row.roomType == 1){
                    return "双人间";
                }
                return "其它";
            },
            typeTitle(row){
                if(row.type == 1){
                    return "按天";
                }
                if(row.type == 2){
                    return "按周";
                }
                if(row.type == 3){
                    return "按月";
                }
                return "其它";
            },



        }
    }
</script>
<style lang="scss" scoped>
    .ElderlyCheckinAssess{
        .demo-table-expand /deep/ label {
            display: inline;
            color: #99a9bf;
        }

        .demo-table-expand /deep/ .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 100%;
        }
    }
</style>
